import React, {forwardRef, useEffect, useImperativeHandle} from 'react';
import {getServerTexts} from '../../../../components/Common/SelectListModal/text';
import {listTypes} from './enum';
import {keys} from '../../../../constants/KeyCodes';
import {useEventListener} from '../../../../hooks/useEventListener';
import {openNavigationModal} from '../../../../_shared/GWTBridge/invoke/genPage';
import {FormActionDialog} from './FormActionDialog';
import {useDialog} from './hooks/useDialog';

type Props = {
    isApiLock: () => boolean;
};

export interface SelectListModalRefType {
    openSelectListModal: (listType: listTypes) => void;
}

export const SelectListModal = forwardRef(({isApiLock}: Props, ref) => {
    const {onDialogClose, onDialogOpen, handleDialogShortcut, isOpen, listType, runInSearchMode} =
        useDialog(isApiLock);

    const handleKeyUp = (e: KeyboardEvent) => {
        if (e.ctrlKey && (e.key === keys.ARROW_DOWN || e.key === keys.ARROW_UP)) {
            onDialogClose();
            openNavigationModal(e.key === keys.ARROW_DOWN);
        }
    };

    useEventListener('keyup', handleKeyUp);
    useEventListener('keydown', handleDialogShortcut);

    useImperativeHandle(
        ref,
        () => ({
            openSelectListModal: onDialogOpen
        }),
        [onDialogOpen]
    );

    useEffect(() => {
        getServerTexts(); // Fetch server Texts
    }, []);

    if (isOpen) {
        return (
            <FormActionDialog
                runInSearchMode={runInSearchMode}
                type={listType}
                onDialogClose={onDialogClose}
            />
        );
    }

    return null;
});
